export default __webpack_public_path__ + "static/media/190629_190332_IMG_3078.fb499e23.jpg";